import React, { useState } from 'react';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { IconButton, Badge } from '@mui/material';

function Carrito({ length, openCart }) {
  //const [items, setItems] = useState([]);
  //const [total, setTotal] = useState(0);

  // Función para agregar un nuevo item al carrito
  // const agregarAlCarrito = (item) => {
  //   setItems([...items, item]);
  //   setTotal(total + item.precio);
  // };

  console.log("Carritooooooo")
  return (
    <div>
      {/* <h2>Carrito de Compras</h2> */}
      <IconButton aria-label="carrito" onClick={() => openCart && openCart()}>
        <Badge badgeContent={length} color="secondary">
          <ShoppingCartIcon />
        </Badge>
      </IconButton>
      {/* <ul>
        {items.map((item, index) => (
          <li key={index}>{item.nombre}</li>
        ))}
      </ul>
      <p>Total: ${total}</p>
      <AgregarAlCarrito agregarAlCarrito={agregarAlCarrito} /> */}
    </div>
  );
}

function AgregarAlCarrito({ agregarAlCarrito }) {
  const handleClick = () => {
    // Simplemente un ejemplo de un nuevo item que se agrega al carrito
    const nuevoItem = {
      nombre: 'Producto de ejemplo',
      precio: 10, // Precio del producto
    };
    agregarAlCarrito(nuevoItem);
  };

  return <button onClick={handleClick}>Agregar al carrito</button>;
}

export default Carrito;
